import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { getproductReq, catprodsReq, outcatReq, incatReq, imgBase } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCross, faFill, faFilter, faPlus, faRemoveFormat, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import SelectIDInput from '../components/selectIdInput';
import SearchSelect from '../components/searchSelect';

class CatProd extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			catid: this.props.match?.params?.id || '',
			product: '',
			allCatprods: null,
			catprods: null,
			category: {},
			products: null,
			search: '',
			errors: { product: '' },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
			id: '',
		};
	}

	componentDidMount() {
		this.catProds();
		this.getPreReqs();
	}

	getPreReqs = async () => {
		try {
			const products = (await getproductReq()).data;
			this.setState({
				products
			});
		} catch (err) {
			alertError("Could not fetch required data");
		}
	}

	searchProducts = (search) => {
		this.setState({ fetchLoading: true });
		catprodsReq({ category: this.props.match?.params?.id, search })
			.then((res) => {
				const { category, supplies: catprods } = res.data;
				this.setState({ category, allCatprods: catprods, catprods, form: false, search });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not fetch products");
			}).finally(() => {
				this.setState({ fetchLoading: false });
			});
	};

	catProds = () => {
		this.setState({ fetchLoading: true });
		catprodsReq({ category: this.props.match?.params?.id, search: this.state.search })
			.then((res) => {
				const { category, supplies: catprods } = res.data;
				this.setState({ category, allCatprods: catprods, catprods, form: false });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not fetch products");
			}).finally(() => {
				this.setState({ fetchLoading: false });
			});
	}

	outCat = (supply, index) => {
		this.setState({ deleteLoading: true });
		outcatReq({ category: this.state.catid, supply })
			.then((res) => {
				// const { catprods } = this.state;
				// catprods.splice(index, 1);
				// this.setState({catprods});
				alertSuccess("Product removed from category");
				this.catProds();
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not remove product from category");
			}).finally(() => {
				this.setState({ deleteLoading: false });
			});
	}

	handleChange = ({ target: { name, value } }) => {
		this.setState({ [name]: value });
	}

	handleSelect = (name, value) => {
		this.setState({ [name]: value });
	}

	validate = () => {
		const { product } = this.state;
		let errors = { product: '' }, isValid = true;

		if (!product || !product[0].id) {
			errors.product = "Select product to continue";
			isValid = false;
		}

		this.setState({ errors });
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { catid: category, product } = this.state;
		if (this.validate()) {
			if (category) {
				this.setState({ loading: true });
				incatReq({ category, supply: product[0].id })
					.then((res) => {
						this.setState({ loading: false });
						alertSuccess("Product added to category");
						this.catProds();
					}).catch((err) => {
						this.setState({ loading: false });
						alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
					});
			}
		}
	}

	filterSelected = () => {
		const { allCatprods } = this.state;
		this.setState({ catprods: allCatprods.filter((cp) => cp.catted) });
	}

	clearFilter = () => {
		const { allCatprods } = this.state;
		this.setState({ catprods: allCatprods });
	}

	inCat = (supply) => {
		const { catid: category } = this.state;
		this.setState({ loading: true });
		incatReq({ category, supply })
			.then((res) => {
				this.setState({ loading: false });
				alertSuccess("Product added to category");
				this.catProds();
			}).catch((err) => {
				this.setState({ loading: false });
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
	}

	navigateAdd = () => {
		this.setState({ id: '', product: '', errors: { product: '' }, loading: false, form: true });
	}

	render() {
		const { catid, product, products, catprods, category, deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { handleChange, handleSelect, handleSubmit, navigateAdd, outCat, inCat, filterSelected, clearFilter } = this;
		return (
			form ?
				<Row style={{ marginLeft: 0, marginRight: 0 }}>
					<Col md={{ span: 4, offset: 4 }} lg={{ span: 4, offset: 4 }} xs={12}>
						<Card style={{ marginTop: '20%' }}>
							<Card.Header>
								<Card.Title style={{ textAlign: 'center' }}>Add Product to {category?.name || 'Category'}</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group>
										<SearchSelect options={products} onChange={handleSelect} value={product} error={errors.product} name="product" label="Product" />
									</Form.Group>

									<Button variant="success" type="submit" style={{ marginLeft: '30%', width: '40%', marginTop: '25px' }} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
											:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
				:
				<Row style={{ marginTop: '20px', marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%' }}>
					{/* Adjusted Search Box */}
					<Col md={6} className="d-flex justify-content-start">
						<Form.Control
							type="text"
							placeholder="Search products..."
							onChange={(e) => this.searchProducts(e.target.value)}
							style={{
								maxWidth: '100%', // Takes full width in the column
								minWidth: '250px', // Minimum width for better responsiveness
								padding: '8px 10px'
							}}
						/>
					</Col>
					<Col md={12} style={{ justifyContent: 'space-between', display: 'flex', marginTop: '10px', marginBottom: '15px' }}>
						<Card.Title>{category?.name}</Card.Title>
						<div>
							<Button variant="success" onClick={filterSelected} size="md" style={{ marginRight: "1rem" }}>
								<FontAwesomeIcon icon={faFilter} /> Filter Selected
							</Button>
							<Button variant="success" onClick={clearFilter} size="md">
								<FontAwesomeIcon icon={faFill} /> Clear Filter
							</Button>
							{/* <Button variant="success" onClick={navigateAdd} size="md">
								<FontAwesomeIcon icon={faPlus} /> Add Product to Category
							</Button> */}
						</div>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(catprods) ?
						catprods.length > 0 ?
							<>
								<Row>
									{catprods.map(({ id, name, price, image, description, /* quantity, */ catted }, i) =>
										<Col md={{ span: 3 }} key={i}>
											<Card className="d-flex justify-content-between flex-row p-2">
												<h3>{name}</h3>
												<div className="course-control-box icons-container d-flex align-self-center">
													{catted ?
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" style={{ color: 'red' }} onClick={(e) => { outCat(id, i) }} />
														</OverlayTrigger>
														:
														<OverlayTrigger overlay={<Tooltip>Add</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faPlus} className="disabled-icon font-16 cursor-pointer" style={{ color: 'green' }} onClick={(e) => { inCat(id, i) }} />
														</OverlayTrigger>
													}
												</div>
											</Card>
										</Col>
									)}
								</Row>
								{/* <div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>Image</th>
											<th>Name</th>
											<th>Quantity</th>
											<th>Description</th>
											<th className="th1">Action</th>
										</tr>
									</thead>
									<tbody>
										{catprods.map(({ id, name, price, image, description, quantity }, i) =>
											<tr key={i}>
												<td>
													<Image fluid  style={{width: 50, height: 50}} src={`${imgBase}${image}`} />
												</td>
												<td>{name}</td>
												<td>{quantity}</td>
												<td>{description}</td>
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" onClick={(e) => { outCat(id, i) }} />
														</OverlayTrigger>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
					</div> */}
							</>
							:
							<p style={{ position: 'fixed', marginLeft: '34%', marginTop: '20%' }}>No products in this category.</p>
						:
						<></>
					}
				</Row>
		);
	}
}

export default CatProd;